import {Route, Routes} from "react-router-dom";

import {LogoutPage} from "../../auth/pages";

export default function LogoutRoute() {
  return (
    <Routes>
      <Route path="/logout" element={<LogoutPage />} />
    </Routes>
  );
}
